<template lang="pug">
</template>

<script>
export default {
  mounted() {
    this.$helpers.logout();
  }
};
</script>
